import { createContext, useContext, useEffect, useState } from 'react';
import { getPreferredTheme, updateHtmlTag, prefersDarkMQ, changeFavicon } from '../../utils/index'

function ThemeProvider({
  children
}) {
  const [theme, setTheme] = useState(() => {
    return getPreferredTheme();
  });

  useEffect(() => {
    if (!theme) {
      return;
    }
    updateHtmlTag(theme);
    if(theme === 'light') {
      changeFavicon('dark');
    } else {
      changeFavicon('light');
    }
  }, [theme]);

  const updateMode = () => {
    setTheme(getPreferredTheme())
  }

  useEffect(() => {
    setTimeout(()=>{
      const body = document.querySelector('body');
      body?.style.setProperty('transition', 'all .86s ease-in-out')
    },1000)
    const mediaQuery = window.matchMedia(prefersDarkMQ);
    mediaQuery.addEventListener('change', updateMode);

    return () => mediaQuery.removeEventListener('change', updateMode);
  },[])


  return (
    <ThemeContext.Provider
      value={{ theme, setTheme }}
    >
      {children}
    </ThemeContext.Provider>
  );
}
const ThemeContext = createContext({
  theme: getPreferredTheme(), 
  setTheme: ()=>{},
});

const useTheme = () => {
  return useContext(ThemeContext);
};

export { useTheme, ThemeProvider };